// @flow
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  mb, px, mr, pb
} from 'styled-components-spacing';

import { fontTeaserItalic } from '@styles/typography';

import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

const { colors } = theme;

export const StyledArticleCard = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  background-color: ${colors.white};
  position: relative;
  ${mb(3.5)}
  cursor: pointer;

  ${breakpoint('desktop')`
    display: flex;
  `}
`;

export const StyledImageCover = styled.div`
  width: 50%;
  aspect-ratio: 3/2;
  position: relative;
  box-sizing: border-box;
  span {
    height: 100%;
    width: 100%;
    position: absolute;
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
  }

  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    height: 50%;
    img {
    object-fit: cover;
    object-position: right-center;
  }
  `}
`;

export const StyledInfoContainer = styled.div`
  width: 50%;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  ${breakpoint('mobile', 'desktop')`
   width: 100%;
   position: unset;
  `}
`;

export const StyledTitleContainer = styled.div`
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  ${px(3.5)}
`;

export const StyledTitle = styled.p`
  margin-bottom: 0%.5rem;
  font-weight: bold;
  color: ${colors.darkBlue};
  line-height: 24px;
  max-height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledDateAndLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${px(3.5)}

  margin-top: auto;
  margin-bottom: 0.5rem;
  & > span {
    ${fontTeaserItalic}
    font-weight: 600;
  }
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${colors.aquaMarine};
  cursor: pointer;
`;

export const StyledSquareCardContainer = styled.div`
  ${mb(3)}
  position: relative;

  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const StyledLink = styled.a`
  display: block;
  text-decoration: none;
  ${breakpoint('desktop')`
    display: block;
  `}
`;

export const StyledReadMore = styled.span`
  & > span {
    color: ${colors.defaultGreen};
    font-style: normal;
    font-weight: bold;
    ${mr(2)}
  }
`;

export const StyledLeadContainer = styled.div`
  ${px(3.5)}
  ${pb(3)}

  ${breakpoint('mobile', 'desktop')`
   display: none;
  `}
`;

export const StyledLead = styled.p`
  font-size: 16px;
  color: ${colors.gray};
  line-height: 24px;
  max-height: 96px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
